<div>
  <div [style.margin-left]="'auto'" [style.height.px]="74"
    [style.margin-right]="'auto'" [style.text-align]="'center'">
    <img id="img_Goods" [style.max-width.px]="74" [style.max-height.px]="74" src="{{data.ImagePath}}">
  </div>
  <div class="align-center">
    <label>{{data.ImageName}}({{data.Priority}})</label>
  </div>
  <div class="align-center">
    <label>{{data.ImageFileName}}</label>
  </div>
  <div class="align-center">
    <label>使用開始：{{data.StartOrderCode}}</label>
  </div>
</div>
